import React from 'react';
import { TableRow } from './TableRow';
import { NoRows } from '../../../layout/Table/NoRows';

function TableBody(props) {
  const renderRows = () => {
    const { orders } = props;

    if (!Array.isArray(orders) || orders.length === 0) {
      return <NoRows colSpan="8"/>;
    }

    return orders.map(renderRow);
  };

  const renderRow = (order, index) => {
    const { actionCallback } = props;

    return (
      <TableRow
        shouldRenderFields={props.shouldRenderFields}
        key={ index }
        order={ order }
        actionCallback={ actionCallback }
        index= { index }
      />
    )
  }
    return (
      <tbody>
      { renderRows() }
      </tbody>
    )
}

export { TableBody };
